var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square",style:({'--icon-square-color': _vm.currentColors.background})},[_c('icon',_vm._b({},'icon',_vm.iconProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }